/** Same members regardless of order. @param {string[]} a @param {string[]} b */
export function sameSet(a, b) {
  if (a.length !== b.length) return false;
  const set = new Set(a);
  return b.every((x) => set.has(x));
}

/** Number of added + removed entries between the server selection and a draft. @param {string[]} server @param {string[]} draft */
export function changeCount(server, draft) {
  const before = new Set(server);
  const after = new Set(draft);
  let n = 0;
  for (const x of after) if (!before.has(x)) n += 1;
  for (const x of before) if (!after.has(x)) n += 1;
  return n;
}

/** Tabs of the client detail page. */
export const MANDATE_TABS = [
  { id: 'einheiten', label: 'Einheiten' },
  { id: 'kostenkonten', label: 'Kostenkonten' },
  { id: 'mitglieder', label: 'Mitglieder' },
  { id: 'berichte', label: 'Monatsberichte' },
];

/** Report sections in API order (mandate_clients flags, SE clients.send_*). */
export const REPORT_FLAGS = [
  { key: 'send_open_items_list', label: 'Offene-Posten-Liste', hint: 'Übersicht je Liegenschaft + Einzelposten als Excel-Anhang' },
  { key: 'send_costs_summary', label: 'Kostensummen des Monats', hint: 'nur freigegebene Kostenkonten, je Liegenschaft' },
  { key: 'send_monthly_yield', label: 'Monatliche Rendite', hint: 'Jahresmiete (Soll) und Bruttorendite je Liegenschaft' },
];

/** Default report month = previous month ("YYYY-MM"). */
export function previousMonth(today = new Date()) {
  const d = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}
